// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file inventory/v1/signal_detail.proto (package inventory.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { DocumentQuote } from "../../artifacts/v1/model_pb";
import { file_artifacts_v1_model } from "../../artifacts/v1/model_pb";
import type { AnalysisQuote } from "../../controls/v1/analysis_result_pb";
import { file_controls_v1_analysis_result } from "../../controls/v1/analysis_result_pb";
import type { Documentation } from "./documentation_pb";
import { file_inventory_v1_documentation } from "./documentation_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file inventory/v1/signal_detail.proto.
 */
export const file_inventory_v1_signal_detail: GenFile = /*@__PURE__*/
  fileDesc("CiBpbnZlbnRvcnkvdjEvc2lnbmFsX2RldGFpbC5wcm90bxIMaW52ZW50b3J5LnYxIpMCCgxTaWduYWxEZXRhaWwSMgoNZG9jdW1lbnRhdGlvbhgBIAEoCzIbLmludmVudG9yeS52MS5Eb2N1bWVudGF0aW9uEhQKCG1hcmtkb3duGAIgASgJQgIYARITCgtjb250cm9sX2lkcxgDIAMoCRI4Cg9kb2N1bWVudF9xdW90ZXMYBCADKAsyGy5hcnRpZmFjdHMudjEuRG9jdW1lbnRRdW90ZUICGAESKgoGcXVvdGVzGAUgAygLMhouY29udHJvbHMudjEuQW5hbHlzaXNRdW90ZRI+ChFtaXRpZ2F0aW9uX2dyb3VwcxgGIAMoCzIjLmludmVudG9yeS52MS5TaWduYWxNaXRpZ2F0aW9uR3JvdXAiNQoVU2lnbmFsTWl0aWdhdGlvbkdyb3VwEg0KBXRpdGxlGAEgASgJEg0KBWl0ZW1zGAIgAygJQrkBChBjb20uaW52ZW50b3J5LnYxQhFTaWduYWxEZXRhaWxQcm90b1ABWkFnaXRodWIuY29tL2xlbWEuYWkvbGVtbWF0YS9hcGkvcHJvdG8vZ2VuL2ludmVudG9yeS92MTtpbnZlbnRvcnl2MaICA0lYWKoCDEludmVudG9yeS5WMcoCDEludmVudG9yeVxWMeICGEludmVudG9yeVxWMVxHUEJNZXRhZGF0YeoCDUludmVudG9yeTo6VjFiBnByb3RvMw", [file_artifacts_v1_model, file_controls_v1_analysis_result, file_inventory_v1_documentation]);

/**
 * SignalDetail holds the enrichment data returned by both GetSignal and
 * GetAlert detail views: documentation, associated control IDs, and evidence
 * quotes. Company context lives on Signal.company_summary.
 *
 * @generated from message inventory.v1.SignalDetail
 */
export type SignalDetail = Message<"inventory.v1.SignalDetail"> & {
  /**
   * @generated from field: inventory.v1.Documentation documentation = 1;
   */
  documentation?: Documentation;

  /**
   * Read only for AssessmentSignal snapshots; live reads put it in `quotes`.
   *
   * @generated from field: string markdown = 2 [deprecated = true];
   * @deprecated
   */
  markdown: string;

  /**
   * @generated from field: repeated string control_ids = 3;
   */
  controlIds: string[];

  /**
   * Kept for protojson AssessmentSignal snapshots, so its number and type must not change.
   *
   * @generated from field: repeated artifacts.v1.DocumentQuote document_quotes = 4 [deprecated = true];
   * @deprecated
   */
  documentQuotes: DocumentQuote[];

  /**
   * @generated from field: repeated controls.v1.AnalysisQuote quotes = 5;
   */
  quotes: AnalysisQuote[];

  /**
   * Resolved from the first level that has any: the org signal's items, the
   * global signal's items, then the signal type's defaults.
   *
   * @generated from field: repeated inventory.v1.SignalMitigationGroup mitigation_groups = 6;
   */
  mitigationGroups: SignalMitigationGroup[];
};

/**
 * Describes the message inventory.v1.SignalDetail.
 * Use `create(SignalDetailSchema)` to create a new message.
 */
export const SignalDetailSchema: GenMessage<SignalDetail> = /*@__PURE__*/
  messageDesc(file_inventory_v1_signal_detail, 0);

/**
 * SignalMitigationGroup is a titled, ordered list of mitigation actions for one
 * audience (for example "Business Owner"). Items carry no status.
 *
 * @generated from message inventory.v1.SignalMitigationGroup
 */
export type SignalMitigationGroup = Message<"inventory.v1.SignalMitigationGroup"> & {
  /**
   * @generated from field: string title = 1;
   */
  title: string;

  /**
   * @generated from field: repeated string items = 2;
   */
  items: string[];
};

/**
 * Describes the message inventory.v1.SignalMitigationGroup.
 * Use `create(SignalMitigationGroupSchema)` to create a new message.
 */
export const SignalMitigationGroupSchema: GenMessage<SignalMitigationGroup> = /*@__PURE__*/
  messageDesc(file_inventory_v1_signal_detail, 1);

